import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { AddCustomReportComponent } from './AddCustomReport/AddCustomReport.component';
import { WorkRequestEditComponent } from './WorkRequestEdit/WorkRequestEdit.component';
import { AddNoteComponent } from './AddNote/AddNote.component';
import { BasicInformationComponent } from './BasicInformation/BasicInformation.component';
import { BlogPostsComponent } from './BlogPosts/BlogPosts.component';
import { OpenWorkflowsComponent } from './open-workflows/open-workflows.component';
import { CompletedTasksComponent } from './CompletedTasks/CompletedTasks.component';
import { ConnectedUsersComponent } from './ConnectedUsers/ConnectedUsers.component';
import { ConnectedUsersSidePanelComponent } from './ConnectedUsersSidePanel/ConnectedUsersSidePanel.component';
import { CustomerContactPreferencesComponent } from './CustomerContactPreferences/CustomerContactPreferences.component';
import { CustomerWorkHistoryComponent } from './CustomerWorkHistory/CustomerWorkHistory.component';
import { CustomerInformationComponent } from './CustomerInformation/CustomerInformation.component';
import { CustomerInformationLimitedComponent } from './CustomerInformationLimited/CustomerInformationLimited.component';
import { CustomerSynopsisComponent } from './CustomerSynopsis/CustomerSynopsis.component';
import { CustomerTodoHistoryComponent } from './CustomerTodoHistory/CustomerTodoHistory.component';
import { CustomerUserComponent } from './CustomerUser/CustomerUser.component';
import { CustomerUsersComponent } from './CustomerUsers/CustomerUsers.component';
import { EditMerchantFieldsComponent } from './EditMerchantFields/EditMerchantFields.component';
import { LocalProfilesComponent } from './local-profiles/local-profiles.component';
import { LoginsAndGoogleSetupComponent } from './logins-and-google-setup/logins-and-google-setup.component';
import { FilesComponent } from './Files/Files.component';
import { FloatingCustomerNoteComponent } from './FloatingCustomerNote/FloatingCustomerNote.component';
import { FloatingCustomerTodoListComponent } from './FloatingCustomerTodoList/FloatingCustomerTodoList.component';
import { ManageCustomerComponent } from './ManageCustomer.component';
import { BloggingDetailsComponent } from './SeoContentSurvey/BloggingDetails/BloggingDetails.component';
import { SurveyComponent } from './SeoContentSurvey/Survey/Survey.component';
import { SeoContentSurveyComponent } from './SeoContentSurvey/SeoContentSurvey.component';
import { MerchantFieldsComponent } from './MerchantFields/MerchantFields.component';
import { MerchantFieldsEditComponent } from './MerchantFieldsEdit/MerchantFieldsEdit.component';
import { NewTicketComponent } from './NewTicket/NewTicket.component';
import { NotesComponent } from './notes/notes.component';
import { NotesAndTicketsComponent } from './notes-and-tickets/notes-and-tickets.component';
import { NotesSummaryComponent } from './notes/notes-summary/notes-summary.component';
import { OnsiteCopyCustomActionComponent } from './OnsiteCopyCustomAction/OnsiteCopyCustomAction.component';
import { OpenTicketsComponent } from './OpenTickets/OpenTickets.component';
import { PendingWorkComponent } from './PendingWork/PendingWork.component';
import { ReviseNoteComponent } from './ReviseNote/ReviseNote.component';
import { UploadCustomerFileComponent } from './UploadCustomerFile/UploadCustomerFile.component';
import { WebsiteAccessComponent } from './WebsiteAccess/website-access.component';
import { WordpressWebsiteReportsComponent } from './WordpressWebsiteReports/WordpressWebsiteReports.component';
import { WorkflowTaskHistoryComponent } from './WorkflowTaskHistory/WorkflowTaskHistory.component';
import { EditImplementationInstructionsComponent } from './EditImplementationInstructions/EditImplementationInstructions.component';
import { EditRejectionInstructionsComponent } from './EditRejectionInstructions/EditRejectionInstructions.component';
import { AllocateWorkComponent } from './AllocateWork/allocate-work.component';
import { WorkPlannerComponent } from './AllocateWork/work-planner/work-planner.component';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { NonworkableTaskTypeFlagComponent } from './AllocateWork/Components/NonworkableTaskTypeFlag/NonworkableTaskTypeFlag.component';
import { TaskTypeFlagComponent } from './AllocateWork/Components/TaskTypeFlag/TaskTypeFlag.component';
import { TaskDetailsComponent } from './task-details/task-details/task-details.component';
import { PageOptimizationTaskDetailsComponent } from './task-details/page-optimization-task-details/page-optimization-task-details.component';
import { WebsitesModule } from '../websites/websites.module';
import { GoogleCustomerAccountsComponent } from './google-customer-accounts/google-customer-accounts.component';
import { GoogleAnalyticsCustomActionComponent } from './GoogleAnalyticsCustomAction/GoogleAnalyticsCustomAction.component';
import { KeywordResearchStrategyUpdateCustomActionComponent } from './keyword-research-strategy-update-custom-action/keyword-research-strategy-update-custom-action.component';
import { CustomerNotificationsComponent } from './customer-notifications/customer-notifications.component';
import { CustomerCampaignComponent } from './customer-campaign/customer-campaign.component';
import { PastWorkComponent } from './AllocateWork/past-work/past-work.component';
import { TaskTypePeriodSelectionComponent } from './AllocateWork/Components/task-type-period-selection/task-type-period-selection.component';
import { WorkPreviewComponent } from './AllocateWork/work-preview/work-preview.component';
import { ReportingDashboardAccessComponent } from './reporting-dashboard-access/reporting-dashboard-access.component';
import { CustomerUsersPriorityComponent } from './customer-users-priority/customer-users-priority.component';
import { TargetKeywordsComponent } from './target-keywords/target-keywords.component';
import { PageCreationCustomActionComponent } from './page-creation-custom-action/page-creation-custom-action.component';
import { PageOptimizationCustomActionComponent } from './page-optimization-custom-action/page-optimization-custom-action.component';

@NgModule({
  declarations: [
    AddCustomReportComponent,
    WorkRequestEditComponent,
    AddNoteComponent,
    BasicInformationComponent,
    BlogPostsComponent,
    CompletedTasksComponent,
    ConnectedUsersComponent,
    ConnectedUsersSidePanelComponent,
    CustomerContactPreferencesComponent,
    CustomerWorkHistoryComponent,
    CustomerInformationComponent,
    CustomerInformationLimitedComponent,
    CustomerSynopsisComponent,
    CustomerTodoHistoryComponent,
    CustomerUserComponent,
    CustomerUsersComponent,
    EditMerchantFieldsComponent,
    LoginsAndGoogleSetupComponent,
    LocalProfilesComponent,
    FilesComponent,
    FloatingCustomerNoteComponent,
    FloatingCustomerTodoListComponent,
    ManageCustomerComponent,
    BloggingDetailsComponent,
    SurveyComponent,
    SeoContentSurveyComponent,
    MerchantFieldsComponent,
    MerchantFieldsEditComponent,
    NewTicketComponent,
    NotesComponent,
    NotesAndTicketsComponent,
    NotesSummaryComponent,
    OnsiteCopyCustomActionComponent,
    WorkflowTaskHistoryComponent,
    EditImplementationInstructionsComponent,
    EditRejectionInstructionsComponent,
    OpenTicketsComponent,
    ReviseNoteComponent,
    UploadCustomerFileComponent,
    WebsiteAccessComponent,
    WordpressWebsiteReportsComponent,
    AllocateWorkComponent,
    WorkPlannerComponent,
    NonworkableTaskTypeFlagComponent,
    TaskTypeFlagComponent,
    TaskDetailsComponent,
    PageOptimizationTaskDetailsComponent,
    GoogleCustomerAccountsComponent,
    OpenWorkflowsComponent,
    PendingWorkComponent,
    GoogleAnalyticsCustomActionComponent,
    KeywordResearchStrategyUpdateCustomActionComponent,
    CustomerNotificationsComponent,
    CustomerCampaignComponent,
    PastWorkComponent,
    TaskTypePeriodSelectionComponent,
    WorkPreviewComponent,
    ReportingDashboardAccessComponent,
    CustomerUsersPriorityComponent,
    TargetKeywordsComponent,
    PageCreationCustomActionComponent,
    PageOptimizationCustomActionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedComponentsModule,
    WebsitesModule
  ],
  exports: [
    NotesComponent,
    WebsiteAccessComponent,
    CustomerInformationLimitedComponent
  ]
})
export class ManageCustomerModule { }
